
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.338 22.498a3.677 3.677 0 01-2.619-1.085L1.087 14.78a3.707 3.707 0 01.127-5.259 3.697 3.697 0 012.551-1.016c.953 0 1.858.36 2.55 1.014l3.622 3.621 7.381-9.841a3.734 3.734 0 012.974-1.484c.807 0 1.575.256 2.221.74a3.684 3.684 0 011.448 2.443 3.683 3.683 0 01-.704 2.752L13.31 21.015a3.729 3.729 0 01-2.972 1.483zM3.769 10.004c-.569 0-1.11.215-1.522.606-.429.406-.673.955-.689 1.545s.199 1.151.605 1.58l6.616 6.617a2.19 2.19 0 001.56.647c.705 0 1.351-.322 1.772-.883L22.057 6.85a2.194 2.194 0 00.419-1.639 2.2 2.2 0 00-.863-1.456 2.192 2.192 0 00-1.323-.441c-.705 0-1.351.322-1.772.884l-7.9 10.534a.75.75 0 01-1.13.08L5.27 10.595a2.177 2.177 0 00-1.501-.591z"}})])
          )
        }
      }
    